import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleNewHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/profiles/new` URL — the canonical segment for accounts
 * on the taxonomy rename (the Ember router flag-swaps `people`/`profiles`).
 * Flag off it renders the embedded Ember host; flag on it forwards to the
 * migrated URL, same as the `/journeys/people/new` twin.
 */
function JourneysProfilesNewRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleNewHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/profiles/new')({
  component: JourneysProfilesNewRoute,
});
